import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import { addSubscriptionAction, creationClientAction, OtpVerifyAction, resendOtpAction, resendPaymentLikeAction, setAddSubscriptionAction, setCreationClientAction, setNextActionUpdated, setOtpVerifyAction, setResendOtpAction, setResendPaymentLikeAction, setSubscriptionResponseData } from "../reducers/adminCreationSlice";
import moment from "moment";
import { getUserAction } from "../reducers/userSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */


function* creationClientSaga(payload: { payload: any }): any {
    yield put(setLoaderAction(true));
    yield put(setNotificationAction({ message: [], severity: "error" }));

    const {confirmPassword, ...newPayload} = payload?.payload;
    try {
      const apiResponse = yield call<any>(
        callAPI,
        { payload: newPayload },
        "post",
        "auth/signup"
      );
      
      if (apiResponse?.success) {
        apiResponse && handleSuccess(apiResponse);
        yield put(setCreationClientAction(true));
        localStorage.setItem("userEmail", JSON.stringify(payload?.payload?.email));
        localStorage.setItem("userName",JSON.stringify(payload?.payload?.username));
        localStorage.setItem("password",JSON.stringify(payload?.payload?.password));
      }
    } catch (error: any) {
     
      error?.response && handleError(error?.response);
      error?.code === "ERR_NETWORK" && handleError(error);
    }
    yield put(setLoaderAction(false));
  }

  function* OtpVerifySaga(payload: { payload: any }): any {
    yield put(setLoaderAction(true));
    yield put(setNotificationAction({ message: [], severity: "error" }));
  
    const {email, ...newPayload} = payload?.payload;
    try {
      const apiResponse = yield call<any>(
        callAPI,
        { payload: newPayload },
        "post",
        "auth/verify-otp"
      );
     
      if (apiResponse?.success) {
        apiResponse && handleSuccess(apiResponse);
        yield put(setOtpVerifyAction(true));
      }
    } catch (error: any) {
      
      error?.response && handleError(error?.response);
      error?.code === "ERR_NETWORK" && handleError(error);
      yield put(setOtpVerifyAction(false));
    }
    yield put(setLoaderAction(false));
  }

  function* resendOtpSaga(payload: { payload: any }): any {
    yield put(setLoaderAction(true));
    yield put(setNotificationAction({ message: [], severity: "error" }));
   
    const {email,otp, ...newPayload} = payload?.payload;
    try {
      const apiResponse = yield call<any>(
        callAPI,
        { payload: newPayload },
        "post",
        "auth/resend-otp"
      );
    
      if (apiResponse?.success) {
        apiResponse && handleSuccess(apiResponse);
        yield put(setResendOtpAction(true));
      }
    } catch (error: any) {
      
      error?.response && handleError(error?.response);
      error?.code === "ERR_NETWORK" && handleError(error);
    }
    yield put(setLoaderAction(false));
  }

  function removeBlankAttributes(obj: any) {
    const result: any = {};
    for (const key in obj) {
      if (obj[key] !== null && obj[key] !== undefined && obj[key] !== "") {
        if (
          key === "vatPercent" ||
          // key === "vatRegNo" ||
          key === "extendedLiabilityPercent" ||
          key === "extendedLiabilityTax" ||
          key === "insuranceFixedRate" ||
          key === "subscriptionCost" ||
          key === "discount" ||
          key === "amountPayable"
        ) {
          // if (/^\d*$/.test(obj[key])) {
          if(/^\d+(\.\d{0,2})?$/.test(obj[key])) {
            // result[key] = parseInt(obj[key], 10); // Parse to integer
            result[key] = Number(obj[key]);
          } else {
            result[key] = obj[key];
          }
        } else {
          result[key] = obj[key];
        }
      }
    }
    return result;
  }

  function* addSubscriptionSaga(payload: { payload: any }): any {
    yield put(setLoaderAction(true));
    yield put(setNotificationAction({ message: [], severity: "error" }));
 
    const {tenantId,renewsOn, ...newPayload} = payload?.payload;
    try {
      const planObj = removeBlankAttributes(newPayload);
      if(planObj?.startDate && planObj?.endDate){
        // Convert endDate from "DD/MM/YYYY" to "MM/DD/YYYY"
  const formattedEndDate = moment(planObj?.endDate, "DD/MM/YYYY").format("MM/DD/YYYY");
        planObj.term = `${moment(planObj?.startDate).format("MM/DD/YYYY")} - ${formattedEndDate}`;
        planObj.endDate = formattedEndDate;
      }
      if(planObj?.planId){
        if(!planObj?.status){
          planObj.status = 'active'
        }
      }
     
      const apiResponse = yield call<any>(
        callAPI,
        { payload: planObj },
        "post",
        `my-subscriptions`
      );
     
      if (apiResponse?.success === true) {
        apiResponse && handleSuccess(apiResponse);
        localStorage.setItem("nextAction",JSON.stringify(apiResponse?.data?.nextAction));
        if(apiResponse?.data?.nextAction === 'dashboard'){
          yield put(setNextActionUpdated(true));
        }
        yield put(setAddSubscriptionAction(true));
        yield put(setSubscriptionResponseData(apiResponse?.data));
        apiResponse && handleSuccess(apiResponse);
      
      }
    } catch (error: any) {
     
      // error?.response && handleError(error?.response?.data)
      error?.response && handleError(error?.response);
      error?.code === "ERR_NETWORK" && handleError(error);
    }
    yield put(setLoaderAction(false));
  }

  function* resendPaymentLikeSaga(payload: { payload: any }): any {
    yield put(setLoaderAction(true));
    yield put(setNotificationAction({ message: [], severity: "error" }));
   
    const {email,otp, ...newPayload} = payload?.payload;
    try {
      const apiResponse = yield call<any>(
        callAPI,
        { payload: newPayload },
        "get",
        "my-subscriptions?request=resend payment link"
      );
      
      if (apiResponse?.success) {
        apiResponse && handleSuccess(apiResponse);
        yield put(setSubscriptionResponseData(apiResponse?.data));
        yield put(setResendPaymentLikeAction(true));
      }
    } catch (error: any) {
      
      error?.response && handleError(error?.response);
      error?.code === "ERR_NETWORK" && handleError(error);
    }
    yield put(setLoaderAction(false));
  }
 

export function* watchAdminCreation() {
    yield takeLatest<any>(creationClientAction, creationClientSaga);
    yield takeLatest<any>(OtpVerifyAction, OtpVerifySaga);
    yield takeLatest<any>(resendOtpAction, resendOtpSaga);
    yield takeLatest<any>(addSubscriptionAction,addSubscriptionSaga);
    yield takeLatest<any>(resendPaymentLikeAction,resendPaymentLikeSaga);
}